var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "close-preview-container" }, [
    _c("img", {
      staticClass: "close-icon",
      attrs: {
        title: _setup.texts.close,
        src: require("@/assets/images/svg/close-icon.svg"),
        alt: "close icon",
      },
      on: { click: _setup.closeViewerEvent },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }